import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import type { Property } from '../../../../models/property.model';

@Component({
  selector: 'app-numeric-property-display',
  templateUrl: './numeric-property-display.component.html',
  styleUrls: ['./numeric-property-display.component.scss'],
  standalone: false
})
export class NumericPropertyDisplayComponent implements OnChanges {
  @Input() property: Property;

  protected format: string;
  protected value: number;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['property']) {
      this.value = this.property?.Value as number;

      // Round the number if there is a rounding rule
      const roundUpTo = this.property?.Rules?.RoundUpToNearest || 0;
      if (roundUpTo) {
        this.value = Math.ceil(this.value / roundUpTo) * roundUpTo;
      }

      if (this.property?.MeasurementUnit) {
        const numberOfDecimals = this.property.MeasurementUnit.Decimals;
        this.format = `1.${numberOfDecimals}-${numberOfDecimals}`;
      } else {
        this.format = `1.0-0`;
      }
    }
  }
}
